import { Card } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { Content } from "@/features/dashboard/configuracoes/popups/$id/components/PopupsContent";

export const Route = createFileRoute("/_private/dashboard/_settings/configuracoes/popups/$id/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Card withBorder shadow="sm" p="lg" mt="md">
      <Content />
    </Card>
  );
}
